import { useEffect, useState } from 'react';

export interface WindowSize {
  innerWidth: number
  innerHeight: number
  clientWidth: number
  clientHeight: number
}

export function getCurrentDimension (): WindowSize {
  return {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    clientWidth: document.documentElement.clientWidth, // Excluding scrollbar
    clientHeight: document.documentElement.clientHeight // Excluding scrollbar
  };
}

export function useWindowSize (): WindowSize {
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  // This is for the initial page load (or page refresh).
  useEffect(
    () => {
      window.addEventListener('load', () => {
        setScreenSize(getCurrentDimension());
      });
    },
    []
  );
  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    // alert('111');
    window.addEventListener('resize', updateDimension);
    return () => {
      window.removeEventListener('resize', updateDimension);
    };
  }, []);

  return screenSize;
}
